export default {
  landingPageDetails: [],
  templateName: "",
  imageLimit: 0,
  editBannerImage: false,
  editImage1: false,
  editImage2: false,
  editImage3: false,
};
